import { EmailSenderLayout } from "../EmailSenderLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { EmailSenderRouterProps } from "../EmailSenderRouterProps";
import { EmailSenderEntities } from "../EmailSenderEntities";
import { NamirasoftMap } from "namirasoft-site-map";

export interface SentListPageProps extends NSARouterMakerResult, EmailSenderRouterProps
{ }

function SentListPage(props: SentListPageProps)
{
	let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

	return (
		<EmailSenderLayout {...props}
			action={{
				title: "Report",
				description: "View detailed reports of the emails sent, including email address, message, date, and time.",
				menus: {}
			}}
			pages={{
				entity: EmailSenderEntities.sent(props),
				list: {
					ui: {
						search_box: {
							exclude: {
								load_value: (table, column) =>
								{
									if (namirasoft.email_sender.tables.sent.name === table)
									{
										let columns = [
											namirasoft.email_sender.tables.sent.columns.message.name,
											namirasoft.email_sender.tables.sent.columns.result.name,
										]
										return columns.includes(column);
									}
									return false;
								}
							}
						}
					}
				}
			}}
		>
			<></>
		</EmailSenderLayout>
	);
}

export default SentListPage;